module.exports = __webpack_public_path__ + "img/схема_подача_документов.f6c0e7c5.svg";